<template>
    <div id="quote-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Info',
                    to: { path: '/info' },
                },
                { text: !$route.query.id ? 'Tambah Info' : 'Ubah Info' },
            ]"
            divider=">"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ !$route.query.id ? "Tambah Info" : "Ubah Info" }}
        </h3>

        <v-card plain class="pa-4">
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        ID
                    </v-list-item-title>
                    <v-text-field
                        id="ambis_meter_info_id"
                        v-model="form.id"
                        placeholder="ID"
                        required
                        outlined
                        v-on:keypress="
                            /\d/.test(String.fromCharCode($event.keyCode))
                                ? true
                                : $event.preventDefault()
                        "
                        @change="form.id = form.id.replace(/\D/g, '')"
                    />
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Pertanyaan
                    </v-list-item-title>
                    <v-text-field
                        placeholder="Pertanyaan"
                        v-model="form.question"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Jawaban
                    </v-list-item-title>
                    <v-textarea
                        ref="jawaban"
                        counter
                        placeholder="Jawaban"
                        v-model="form.answer"
                        :rules="rules"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>
            <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn
                    depressed
                    class="px-6 py-2 white--text"
                    color="blew"
                    @click="save()"
                >
                    Simpan</v-btn
                >
            </v-card-actions>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "ambis-meter-form",

    components: {
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            isLoading: false,
            rules: [(v) => v.length <= 255 || "Maksimal 255 karakter"],
            infoId: this.$store.state.info.editInfoId,
            form: {
                id: null,
                question: "",
                answer: "",
            },
            addNew: false,
            onDelete: false,
        };
    },

    mounted: function () {
        if (this.$route.query.baru) this.addNew = true;
        if (!_.isEmpty(this.$store.state.info.onEdit))
            this.form = this.$store.state.info.onEdit;
        if (!this.form) {
            this.$router.push("/info");
        }
    },

    destroyed() {
        this.$store.commit("info_clear");
    },

    methods: {
        async save() {
            var context = this;
            if (this.validateForm()) {
                context.isLoading = true;
                try {
                    var oldArr = this.$store.state.info.data;
                    const infos = this.$store.state.info.editInfoId;
                    var raws = this.$store.state.info.raw;
                    this.form.id = parseInt(this.form.id);

                    if (this.addNew) {
                        var newArr = oldArr.filter(
                            (e) => e.id != parseInt(this.form.id),
                        );
                    } else {
                        var newArr = oldArr.filter(
                            (e) =>
                                e.id != infos && e.id != parseInt(this.form.id),
                        );
                    }

                    if (!this.form.id) {
                        newArr = newArr.filter((e) => e.id != 0);
                    } else {
                        if (
                            this.addNew &&
                            oldArr.find((s) => s.id == parseInt(this.form.id))
                        ) {
                            this.$store.commit("showAlert", {
                                message: `ID sudah digunakan`,
                                type: "error",
                            });
                            context.isLoading = false;
                            return 0;
                        } else if (
                            this.form.id != infos &&
                            oldArr.find(
                                (s) => parseInt(s.id) == parseInt(infos),
                            ) &&
                            oldArr.find((s) => s.id == parseInt(this.form.id))
                        ) {
                            this.$store.commit("showAlert", {
                                message: `ID sudah digunakan`,
                                type: "error",
                            });
                            context.isLoading = false;
                            return 0;
                        }

                        newArr = _.uniqBy(newArr, "id");
                        this.form.id = parseInt(this.form.id);
                        newArr.push(this.form);
                    }

                    context.$store.commit("info_edited", newArr);
                    raws.info = _.orderBy(newArr, ["id"], ["asc"]);

                    const parsed = JSON.stringify(raws, null, "\t");
                    const blob = new Blob([parsed], {
                        type: "application/json",
                    });

                    await context.$alioss.put(
                        "config/info_ambis_meter.json",
                        blob,
                    );

                    context.isLoading = false;

                    if (this.addNew) {
                        this.$store.commit("showAlert", {
                            message: `Berhasil Tambah Data`,
                            type: "success",
                        });
                    } else {
                        this.$store.commit("showAlert", {
                            message: `Berhasil Update Data`,
                            type: "success",
                        });
                    }

                    setTimeout(() => {
                        this.$router.push("/info");
                    }, 500);
                } catch (error) {
                    context.isLoading = false;
                }
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        validateForm() {
            var err = false;
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            if (
                this.form.question == "" ||
                this.form.question == " " ||
                !this.form.question
            ) {
                this.$store.commit("showAlert", {
                    message: "Pertanyaan wajib diisi!",
                    type: "error",
                });
                err = true;
            } else if (
                this.form.id == "" ||
                this.form.id == " " ||
                !this.form.id
            ) {
                this.$store.commit("showAlert", {
                    message: "ID wajib diisi!",
                    type: "error",
                });
                err = true;
            } else if (!this.form.answer) {
                this.$store.commit("showAlert", {
                    message: "Jawaban wajib diisi!",
                    type: "error",
                });
                err = true;
            }
            return !err;
        },
    },
};
</script>



// WEBPACK FOOTER //
// InfoForm.vue?c6d47614